import { render, staticRenderFns } from "./SurveyContentShokai.vue?vue&type=template&id=95508ad8&scoped=true&"
import script from "./SurveyContentShokai.vue?vue&type=script&lang=js&"
export * from "./SurveyContentShokai.vue?vue&type=script&lang=js&"
import style0 from "./SurveyContentShokai.vue?vue&type=style&index=0&id=95508ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95508ad8",
  null
  
)

export default component.exports